module.exports = __webpack_public_path__ + "img/titlelogo.bebc4c4d.png";